/**
 * Tamanhos de página do seletor "Exibir" do `DataPagination`, e o padrão de
 * quem abre uma listagem. Ficam fora do arquivo do componente para que a tela
 * que lê o tamanho do endereço use a mesma lista que o seletor mostra: um valor
 * fora dela deixava o seletor em branco (tela abrindo em 20 com opções 10, 25,
 * 50 e 100).
 */
export const OPCOES_TAMANHO_PAGINA = [10, 25, 50, 100] as const;

export const TAMANHO_PAGINA_PADRAO = 25;

/**
 * O tamanho que veio do endereço (`?tamanho=`), se for uma das opções do
 * seletor; senão, o padrão. Link antigo com `tamanho=20` abre no padrão, em vez
 * de abrir com o seletor vazio.
 */
export function tamanhoDePaginaValido(valor: string | number | null | undefined): number {
  const numero = Number(valor);
  return (OPCOES_TAMANHO_PAGINA as readonly number[]).includes(numero)
    ? numero
    : TAMANHO_PAGINA_PADRAO;
}
